// Texte der Lead-Seite in der Tiefe (Runde 7B): Verlauf-Suche und Filter, Log-Reiter, Notiz mit Titel und Formatierung, Aufnahme-Player,
// Adressen, Opportunities. Eigene Datei im Ordner der Lead-Seite (kein Eintrag in `texte.ts`, Regel der Runde 7+8).
export const TL = {
  suche: {
    platzhalter: "Suchen in Notizen, Mails, Anrufen und Namen …",
    tipp: "Suchen (⌘F). Alle Wörter müssen vorkommen, Umlaute und Groß-/Kleinschreibung sind egal.",
    leeren: "Suche leeren",
    keineTreffer: "Keine Treffer.",
    treffer: (n: number) => (n === 1 ? "1 Treffer" : `${n} Treffer`),
  },
  filter: {
    alleNutzer: "Alle Nutzer",
    alleKontakte: "Alle Kontakte",
    alleZeit: "Alle Zeit",
    zuruecksetzen: "Filter zurücksetzen",
    zeitraum: {
      heute: "Heute",
      woche: "Letzte 7 Tage",
      monat: "Letzte 30 Tage",
      quartal: "Letzte 90 Tage",
      eigen: "Zeitraum wählen …",
    },
    von: "Von",
    bis: "Bis",
    anwenden: "Anwenden",
  },
  log: {
    reiter: "Log",
    leer: "Noch keine Änderungen am Lead protokolliert.",
    leerGefiltert: "Keine Änderungen mit diesem Filter.",
    arten: { alle: "Alle Änderungen", lead: "Lead", contact: "Kontakte", task: "Follow-ups", opportunity: "Opportunities", activity: "Gelöschte Aktivitäten" },
    hinweis: "Änderungen am Lead, an Kontakten, Follow-ups und Opportunities. Aus Close übernommen werden die letzten 30 Tage; danach bleibt der Verlauf hier erhalten.",
    mehr: "Ältere laden",
    aufklappen: "Einzelheiten",
    zuklappen: "Weniger",
    alt: "vorher",
    neu: "nachher",
    leerWert: "leer",
    ja: "ja",
    nein: "nein",
    close: "aus Close",
    crm: "im CRM",
    laedt: "Log wird geladen …",
  },
  notiz: {
    titelPlatzhalter: "Titel (optional)",
    textPlatzhalter: "Was ist passiert, was ist als Nächstes zu tun?",
    marker: "Marker",
    formatEntfernen: "Formatierung entfernen",
    baustein: "Textbaustein",
    hinweisBearbeiten: "Die Formatierung bleibt erhalten.",
  },
  aufnahme: {
    abspielen: "Aufnahme abspielen",
    mailbox: "Mailbox-Nachricht abspielen",
    pause: "Pause",
    laeuft: "Läuft",
    tempo: "Abspielgeschwindigkeit",
    mehr: "Mehr",
    linkKopieren: "Link kopieren",
    linkKopiert: "Link zur Aufnahme kopiert (nur mit Anmeldung im CRM abrufbar).",
    herunterladen: "Herunterladen",
    abgelaufen: "Abgelaufen",
    nichtAbrufbar: "Die Aufnahme lässt sich nicht abspielen.",
    laeuftAb: (iso: string | null | undefined, jetzt = Date.now()): string | null => {
      if (!iso) return null;
      const diff = new Date(iso).getTime() - jetzt;
      if (!Number.isFinite(diff)) return null;
      if (diff <= 0) return "abgelaufen";
      const std = diff / 3_600_000;
      if (std >= 36) return `läuft in ${Math.round(std / 24)} T. ab`;
      if (std >= 1.5) return `läuft in ${Math.round(std)} Std. ab`;
      return "läuft bald ab";
    },
  },
  adresse: {
    hinzufuegen: "Adresse hinzufügen …",
    bearbeiten: "Adresse bearbeiten",
    art: "Art",
    arten: { business: "Geschäft", mailing: "Post", other: "Sonstige" } as Record<string, string>,
    strasse: "Straße und Nr.",
    zusatz: "Zusatz",
    plz: "PLZ",
    ort: "Ort",
    bundesland: "Bundesland",
    land: "Land",
    weitere: "Weitere Adresse",
    entfernen: "Adresse entfernen",
    speichern: "Speichern",
    abbrechen: "Abbrechen",
    gespeichert: "Adresse gespeichert.",
    nichtGespeichert: "Adresse nicht gespeichert",
    landHinweis: "Zwei Buchstaben, z. B. DE",
  },
  opportunity: {
    anlegen: "Opportunity anlegen",
    aendern: "Opportunity ändern",
    keine: "Keine Opportunities.",
    anlegenLink: "Opportunity anlegen",
    gespeichert: "Opportunity gespeichert.",
    statusGeaendert: (s: string) => `Opportunity: ${s}`,
    statusNicht: "Status der Opportunity nicht geändert",
    gewonnen: "Gewonnen",
    verloren: "Verloren",
  },
  kopf: {
    eckdaten: "Eckdaten",
    ort: "Ort",
    leadSeit: "Lead seit",
    letzteAktivitaet: "Letzte Aktivität",
    abgleich: "Zuletzt aus Close geladen",
    angelegtVon: "Angelegt von",
    keine: "—",
  },
  zusammen: {
    mitLead: (name: string) => `Zusammengeführt mit ${name}`,
    zumZiel: "Zum zusammengeführten Lead",
    geloescht: "Dieser Lead wurde gelöscht.",
    zurListe: "Zur Liste",
  },
} as const;
